import { render } from "./ActiveProjects.vue?vue&type=template&id=688d6f20&scoped=true"
import script from "./ActiveProjects.vue?vue&type=script&lang=js"
export * from "./ActiveProjects.vue?vue&type=script&lang=js"

import "./ActiveProjects.vue?vue&type=style&index=0&id=688d6f20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688d6f20"]])

export default __exports__